(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SCRIPT_ID = 'yotpo-site-reviews-script';
    const DYNAMIC_SELECTOR = '[data-reviews-carousel-dynamic-content]';
    const MANUAL_SELECTOR = '[data-reviews-carousel-manual-content]';
    const SCRIPT_READY_ATTR = 'data-yotpo-ready';
    const SCRIPT_ERROR_ATTR = 'data-yotpo-error';
    const SCRIPT_LOAD_TIMEOUT_MS = 8000;
    const INIT_RETRY_DELAY_MS = 300;
    const INIT_MAX_RETRIES = 10;
    let scriptLoadingPromise;

    const waitForVisibility = (element) =>
      new Promise((resolve) => {
        if (!('IntersectionObserver' in window)) {
          resolve(true);
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            const firstEntry = entries?.[0];
            if (firstEntry?.isIntersecting) {
              observer.disconnect();
              resolve(true);
            }
          },
          { rootMargin: '200px' }
        );

        observer.observe(element);
      });

    const loadScript = (appKey) => {
      if (scriptLoadingPromise) return scriptLoadingPromise;

      scriptLoadingPromise = new Promise((resolve, reject) => {
        const resolveIfReady = () => {
          const yotpoWidgetsContainer = window?.yotpoWidgetsContainer;
          if (typeof yotpoWidgetsContainer?.initWidgets === 'function') {
            resolve(true);
            return true;
          }
          return false;
        };

        const existing = document.getElementById(SCRIPT_ID);
        if (existing) {
          if (existing.getAttribute(SCRIPT_READY_ATTR) === 'true') {
            resolve(true);
            return;
          }
          if (existing.getAttribute(SCRIPT_ERROR_ATTR) === 'true') {
            reject(new Error('Yotpo script failed to load'));
            return;
          }
          if (resolveIfReady()) {
            return;
          }

          let isSettled = false;
          const settleOnce = (callback) => () => {
            if (isSettled) return;
            isSettled = true;
            window.clearTimeout(timeoutId);
            callback();
          };
          const timeoutId = window.setTimeout(
            settleOnce(() => {
              if (resolveIfReady()) return;
              reject(new Error('Yotpo script failed to load'));
            }),
            SCRIPT_LOAD_TIMEOUT_MS
          );

          existing.addEventListener('load', settleOnce(() => resolve(true)), { once: true });
          existing.addEventListener(
            'error',
            settleOnce(() => {
              existing.setAttribute(SCRIPT_ERROR_ATTR, 'true');
              reject(new Error('Yotpo script failed to load'));
            }),
            { once: true }
          );
          return;
        }

        const script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.defer = true;
        script.src = `https://cdn-widgetsrepository.yotpo.com/v1/loader/${appKey}`;
        script.onload = () => {
          script.removeAttribute(SCRIPT_ERROR_ATTR);
          script.setAttribute(SCRIPT_READY_ATTR, 'true');
          resolve(true);
        };
        script.onerror = () => {
          script.setAttribute(SCRIPT_ERROR_ATTR, 'true');
          reject(new Error('Yotpo script failed to load'));
        };
        document.head.appendChild(script);
      });
      return scriptLoadingPromise;
    };

    const initYotpo = () => {
      try {
        const yotpoWidgetsContainer = window?.yotpoWidgetsContainer;
        if (typeof yotpoWidgetsContainer?.initWidgets === 'function') {
          yotpoWidgetsContainer.initWidgets();
          return true;
        }
        return false;
      } catch (error) {
        return false;
      }
    };

    const wait = (delay) =>
      new Promise((resolve) => {
        window.setTimeout(resolve, delay);
      });

    const applyManualFallback = (sectionElement, dynamicContainer, manualContainer) => {
      const hasManualReviews = sectionElement.dataset.hasManualReviews === 'true';
      const showManualPlaceholder = sectionElement.dataset.showManualPlaceholder === 'true';

      dynamicContainer?.classList.add('is-hidden');

      if (hasManualReviews || showManualPlaceholder) {
        sectionElement.hidden = false;
        manualContainer?.classList.remove('is-hidden');
        return;
      }

      manualContainer?.classList.add('is-hidden');
      sectionElement.hidden = true;
    };

    const initYotpoWithRetry = async () => {
      for (let attempt = 0; attempt <= INIT_MAX_RETRIES; attempt += 1) {
        const initialized = initYotpo();
        if (initialized) return true;
        if (attempt < INIT_MAX_RETRIES) {
          await wait(INIT_RETRY_DELAY_MS);
        }
      }
      return false;
    };

    const bootstrapSection = async (sectionElement) => {
      const dynamicEnabled = sectionElement.dataset.enableDynamic === 'true';
      const hasYotpoConfig = sectionElement.dataset.hasYotpoConfig === 'true';
      const appKey = sectionElement.dataset.yotpoAppKey;
      const dynamicContainer = sectionElement.querySelector(DYNAMIC_SELECTOR);
      const manualContainer = sectionElement.querySelector(MANUAL_SELECTOR);

      if (!dynamicEnabled) {
        return;
      }

      if (!dynamicContainer || !manualContainer) {
        return;
      }

      if (!hasYotpoConfig || !appKey) {
        applyManualFallback(sectionElement, dynamicContainer, manualContainer);
        return;
      }

      try {
        await waitForVisibility(sectionElement);
        await loadScript(appKey);

        const initialized = await initYotpoWithRetry();
        if (!initialized) {
          applyManualFallback(sectionElement, dynamicContainer, manualContainer);
          return;
        }

        dynamicContainer.classList.remove('is-hidden');
        manualContainer.classList.add('is-hidden');
      } catch (error) {
        applyManualFallback(sectionElement, dynamicContainer, manualContainer);
        return;
      }
    };

    const initialize = () => {
      const sections = document.querySelectorAll('[data-reviews-carousel]');
      sections.forEach((sectionElement) => {
        bootstrapSection(sectionElement);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
